import { render, staticRenderFns } from "./QuestionExplanation.vue?vue&type=template&id=f606f4d4&scoped=true"
import script from "./QuestionExplanation.vue?vue&type=script&lang=ts"
export * from "./QuestionExplanation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f606f4d4",
  null
  
)

export default component.exports